// Javascript EntryPoint

import "@babel/polyfill";

// swiperを設定する
import swiper from './parts/swiper';

const menuOpen = document.querySelector(".hamburger-menu");
menuOpen.addEventListener("click",function(e){
    document.querySelector("body").classList.add("fixed");
    document.querySelector("nav.global-navi").classList.add("show");
});

const menuClose = document.querySelector(".menu-close");
menuClose.addEventListener("click",function(e){
    const element = document.querySelector("nav.global-navi");
    element.addEventListener("transitionend",function(){
        document.querySelector("body").classList.remove("fixed");
    },{once:true});
    element.classList.remove("show");
});

